import { useLocation } from 'react-router-dom'

import { useCurrentTenantConfig } from '..'
import { TenantConfigurator } from './TenantConfigurator'
import { TenantValidator } from './TenantValidator'

type TenantContainerProps = {
  children?: React.ReactNode
}

export const TenantContainer: React.FC<TenantContainerProps> = ({
  children,
}) => {
  const { pathname } = useLocation()
  const { tenantId } = useCurrentTenantConfig()

  if (
    !tenantId &&
    pathname &&
    !pathname.toLowerCase().startsWith('/set-tenant')
  ) {
    // return <Navigate to="/set-tenant" />
    return <TenantConfigurator />
  }

  if (!pathname.toLowerCase().startsWith('/set-tenant')) {
    return (
      <TenantValidator tenantId={tenantId as string}>
        {children}
      </TenantValidator>
    )
  }

  return <>{children}</>
}
